import classNames from 'classnames';
import * as React from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';
import { Question, QuestionState } from './ViagraFormTypings';

interface ViagraFormAnswersButtonsProps {
    questionIndex: number;
    subQuestionIndex?: number;
    setQuestionAnswer: (answer: QuestionState, questionIndex: number, subQuestionIndex?: number) => void;
    question: Question;
}

export const ViagraFormAnswersButtons = ({ questionIndex, setQuestionAnswer, subQuestionIndex, question }: ViagraFormAnswersButtonsProps) => {
    return (
        <>
            <label className={classNames('ViagraForm__QuestionButton', question.value === QuestionState.Yes && 'ViagraForm__QuestionButton--Red')}>
                <input
                    type="radio"
                    name={`question-${questionIndex}${subQuestionIndex || ''}`}
                    onChange={() => setQuestionAnswer(QuestionState.Yes, questionIndex, subQuestionIndex)}
                />
                <span className="ViagraForm__QuestionLabel">{getTranslation(keys['viagraForm.yes'])}</span>
            </label>
            <label className="ViagraForm__QuestionButton">
                <input
                    type="radio"
                    name={`question-${questionIndex}${subQuestionIndex || ''}`}
                    onChange={() => setQuestionAnswer(QuestionState.No, questionIndex, subQuestionIndex)}
                />
                <span className="ViagraForm__QuestionLabel">{getTranslation(keys['viagraForm.no'])}</span>
            </label>
        </>
    );
};
